<template>
  <div class="spinner-root">
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
    <div class="spinner-element" />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>

<style scoped>
@keyframes uil-default-anim {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.spinner-root {
  display: block;
  position: relative;
  background: none;
  width: 20px;
  height: 20px;
  transform: scale(0.13) translate3d(-87px, -87px, 0);

  & > .spinner-element {
    top: 80px;
    left: 93px;
    width: 14px;
    height: 40px;
    border-radius: 10px;
    position: absolute;
    background: var(--c-primary-color-2);
    animation: uil-default-anim 1s linear infinite;
  }

  & > .spinner-element:nth-of-type(1) {
    transform: rotate(0deg) translate(0, -60px);
    animation-delay: -0.5s;
  }

  & > .spinner-element:nth-of-type(2) {
    transform: rotate(30deg) translate(0, -60px);
    animation-delay: -0.4166666666666667s;
  }

  & > .spinner-element:nth-of-type(3) {
    transform: rotate(60deg) translate(0, -60px);
    animation-delay: -0.33333333333333337s;
  }

  & > .spinner-element:nth-of-type(4) {
    transform: rotate(90deg) translate(0, -60px);
    animation-delay: -0.25s;
  }

  & > .spinner-element:nth-of-type(5) {
    transform: rotate(120deg) translate(0, -60px);
    animation-delay: -0.16666666666666669s;
  }

  & > .spinner-element:nth-of-type(6) {
    transform: rotate(150deg) translate(0, -60px);
    animation-delay: -0.08333333333333331s;
  }

  & > .spinner-element:nth-of-type(7) {
    transform: rotate(180deg) translate(0, -60px);
    animation-delay: 0s;
  }

  & > .spinner-element:nth-of-type(8) {
    transform: rotate(210deg) translate(0, -60px);
    animation-delay: 0.08333333333333337s;
  }

  & > .spinner-element:nth-of-type(9) {
    transform: rotate(240deg) translate(0, -60px);
    animation-delay: 0.16666666666666663s;
  }

  & > .spinner-element:nth-of-type(10) {
    transform: rotate(270deg) translate(0, -60px);
    animation-delay: 0.25s;
  }

  & > .spinner-element:nth-of-type(11) {
    transform: rotate(300deg) translate(0, -60px);
    animation-delay: 0.33333333333333337s;
  }

  & > .spinner-element:nth-of-type(12) {
    transform: rotate(330deg) translate(0, -60px);
    animation-delay: 0.41666666666666663s;
  }
}

.theme--green {
  .spinner-element {
    background: var(--c-primary-color-2);
  }
}

.theme--original-green {
  .spinner-element {
    background: var(--c-primary-color-3);
  }
}

.theme--white {
  .spinner-element {
    background: var(--c-primary-neutral-3);
  }
}
</style>
